import { render, staticRenderFns } from "./OrderDialog.vue?vue&type=template&id=72991666"
import script from "./OrderDialog.vue?vue&type=script&lang=js"
export * from "./OrderDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderDialog.vue?vue&type=style&index=0&id=72991666&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports